module.exports = __webpack_public_path__ + "static/gallery26-27ccb76f6e6f15a4da88d7cecc968be4.jpg";